import { memo } from 'react';

import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import {
  IconDownLoad02,
  CouponBgImg01,
  CouponBgImg02,
  CouponBgImg01Pc,
} from '@wconcept/wconcept-ui-renewal/src/components/atoms/svg';

import * as S from './style';

interface IProps {
  type?: 'list' | 'card' | string;
  mainColor?: string;
  textColor?: 'white' | 'black' | string;
  title?: string;
  desc?: string;
  isDesktop?: boolean;
  onClick?: () => void;
}

const CouponItem = ({
  type = 'list',
  mainColor = '#000',
  textColor = 'white',
  title,
  desc,
  isDesktop,
  onClick,
}: IProps) => (
  <S.CouponItem
    className={`mega-coupon-item item type-${type}`}
    $type={type}
    $mainColor={mainColor}
    $textColor={textColor}
  >
    <Button onClick={onClick}>
      <div className="bg-wrap">
        {type === 'list' && isDesktop && <CouponBgImg01Pc />}
        {type === 'list' && !isDesktop && <CouponBgImg01 />}
        {type !== 'list' && <CouponBgImg02 />}
      </div>
      <div className="text-wrap">
        <Text className="title" block>
          {title}
        </Text>
        {desc && (
          <Text
            className="desc"
            size={11}
            weight={500}
            lineHeight={14}
            ellipsis={1}
            block
          >
            {desc}
          </Text>
        )}
      </div>
      {type === 'card' && <IconDownLoad02 />}
    </Button>
  </S.CouponItem>
);

export default memo(CouponItem);
